export class NoInstallationUserController {
    /* @ngInject */
    constructor($cookies) {
        this.$cookies = $cookies;
        this.destinationInstallation = this.$cookies.get('x-egto-worker-name');
    }

}

NoInstallationUserController.$inject = ['$cookies'];
